import { render, staticRenderFns } from "./ValuePerDepartment.vue?vue&type=template&id=a6bc27ae&"
import script from "./ValuePerDepartment.vue?vue&type=script&lang=js&"
export * from "./ValuePerDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports